import { React, Table } from '@1337lawyers/design';

export const ReviewerSupport = () => (
  <Table
    headers={['ID', 'Time Requested', 'Reviewer Name', 'Message']}
    data={[]}
  />
);
